/**
 * Per-browser memory of "this browser has already been sent to the mandate
 * wizard" (owner decision 2026-10-06, option 1).
 *
 * AppShell uses it for the one-time mandate-first redirect on arrival at
 * /dashboard: a user with no active mandate is sent to /dashboard/mandate/new
 * the first time, and never again from that browser. It is a per-browser
 * convenience only, not a record of anything the server knows.
 *
 * Every storage access is wrapped in try/catch. If storage is blocked or
 * unavailable, `hasSeenMandateWizard()` reports true, so the redirect is
 * skipped and the app renders normally instead of looping or crashing.
 */

export const MANDATE_WIZARD_SEEN_KEY = 'mandate_wizard_seen_v1';

export function hasSeenMandateWizard(): boolean {
  try {
    return window.localStorage.getItem(MANDATE_WIZARD_SEEN_KEY) === 'true';
  } catch {
    // Storage unavailable: treat as seen so the redirect never fires.
    return true;
  }
}

export function markMandateWizardSeen(): void {
  try {
    window.localStorage.setItem(MANDATE_WIZARD_SEEN_KEY, 'true');
  } catch {
    // Storage not writable: nothing to remember. Reads still fail closed
    // when storage is fully blocked; a readable-but-unwritable store could
    // repeat the root redirect, which is a one-hop wizard visit, not a loop.
  }
}
